import LocationJson from './interfaces/LocationJson'
import LocationTranslation from './LocationTranslation'
import Translatable from '../shared/interfaces/Translatable'
import { Locales } from 'src/i18n'
import Event from './Event'

export default class Location implements Translatable {
  id: number
  event: Event
  translations: { [locale: string]: LocationTranslation }

  constructor(
    id: number,
    event: Event,
    translations: { [locale: string]: LocationTranslation },
  ) {
    this.id = id
    this.event = event
    this.translations = translations
  }

  findTranslationByLocale(locale: Locales): LocationTranslation | null {
    return this.translations[locale] ?? null
  }

  translate(locale: Locales, fallbackLocale: Locales) {
    let translation = this.findTranslationByLocale(locale)

    if (!translation) {
      translation = this.findTranslationByLocale(fallbackLocale)
    }

    return translation
  }

  static fromJson(data: LocationJson) {
    return new this(
      data.id,
      Event.fromJson(data.event),
      data.translations.reduce(
        (previous, current) => ({
          ...previous,
          [current.locale]: LocationTranslation.fromJson(current),
        }),
        {},
      ),
    )
  }

  toJson(): LocationJson {
    return {
      id: this.id,
      event: this.event.toJson(),
      translations: Object.values(this.translations).map((t) => t.toJson()),
    }
  }
}
